import axios from 'axios';
import { createAction } from '@reduxjs/toolkit';
import { navigationActions } from '@employee/simplenavigation';
import { footerActions } from '@employee/footer';
import recursiveRetry from '@employee/recursiveretry';

export const setName = createAction('layout/setName');

function onSuccess(res) {
    return dispatch => {
        dispatch(navigationActions.onSuccess(res));
        dispatch(footerActions.onSuccess(res));
    };
}

function onFailure(err) {
    return dispatch => {
        dispatch(navigationActions.onFailure(err));
        dispatch(footerActions.onFailure(err));
    };
}

export default function getNavAndFooterData(endpoint) {
    const request = () => axios.get(endpoint);
    return recursiveRetry({ request, onSuccess, onFailure });
}
